import { SettingName } from '../../Types';
import { actionTypes } from './actions';
export const PlayerUIReducer = (state, action) => {
    var _a;
    let isThisModalOpen;
    switch (action.type) {
        case actionTypes.SEEKING_STARTED:
            return Object.assign(Object.assign({}, state), { isOnLiveEdge: null, isSeeking: true });
        case actionTypes.SEEKING_ENDED:
            return Object.assign(Object.assign({}, state), { isSeeking: false });
        case actionTypes.DRAG_SEEKING_STARTED:
            return Object.assign(Object.assign({}, state), { isOnLiveEdge: null, isSeeking: true, isDragSeeking: true });
        case actionTypes.DRAG_SEEKING_ENDED:
            return Object.assign(Object.assign({}, state), { isSeeking: false, isDragSeeking: false });
        case actionTypes.OPEN_MODAL:
            return Object.assign(Object.assign({}, state), { isAnyModalOpen: true, [action.modal]: Object.assign(Object.assign({}, state[action.modal]), { isOpen: true }) });
        case actionTypes.CLOSE_MODAL:
            return Object.assign(Object.assign({}, state), { isAnyModalOpen: false, [action.modal]: Object.assign(Object.assign({}, state[action.modal]), { isOpen: false }) });
        case actionTypes.TOGGLE_MODAL:
            isThisModalOpen = state[action.modal].isOpen;
            return Object.assign(Object.assign({}, state), { isAnyModalOpen: !isThisModalOpen, [action.modal]: Object.assign(Object.assign({}, state[action.modal]), { isOpen: !isThisModalOpen, setting: (_a = action.setting) !== null && _a !== void 0 ? _a : SettingName.AudioSubtitles }) });
        case actionTypes.RELATIVE_SEEK:
            return Object.assign(Object.assign({}, state), { relativeSeekValue: state.relativeSeekValue + action.relativeSeekAmount, seekAction: 'relative' });
        case actionTypes.RELATIVE_SEEK_COMPLETED:
            return Object.assign(Object.assign({}, state), { relativeSeekValue: null });
        case actionTypes.ABSOLUTE_SEEK:
            return Object.assign(Object.assign({}, state), { seekAction: 'absolute', dvrPoint: action.dvrPoint });
        case actionTypes.VOLUME_OPEN:
            return Object.assign(Object.assign({}, state), { isVolumeOpened: true });
        case actionTypes.VOLUME_CLOSE:
            return Object.assign(Object.assign({}, state), { isVolumeOpened: false });
        case actionTypes.SHOW_UI:
            return Object.assign(Object.assign({}, state), { uiDisplayed: true, uiHidden: false });
        case actionTypes.HIDE_UI:
            return Object.assign(Object.assign({}, state), { uiDisplayed: false });
        case actionTypes.HIDE_UI_COMPLETED:
            return Object.assign(Object.assign({}, state), { uiHidden: true });
        case actionTypes.TV_SEEKING_ENABLED:
            return Object.assign(Object.assign({}, state), { TVseekingEnabled: true });
        case actionTypes.TV_SEEKING_DISABLED:
            return Object.assign(Object.assign({}, state), { TVseekingEnabled: false });
        case actionTypes.BINGE_WATCHING_OVERLAY_SHOW:
            return Object.assign(Object.assign({}, state), { bingeWatchingOverlay: {
                    isOpen: true,
                    isDismissed: false,
                    remainingTime: action.remainingTime,
                } });
        case actionTypes.BINGE_WATCHING_OVERLAY_HIDE:
            return Object.assign(Object.assign({}, state), { bingeWatchingOverlay: {
                    isOpen: false,
                    isDismissed: action.isFromUserAction,
                    remainingTime: -1,
                } });
        case actionTypes.BINGE_WATCHING_OVERLAY_SET_REMAINING_TIME:
            return Object.assign(Object.assign({}, state), { bingeWatchingOverlay: Object.assign(Object.assign({}, state.bingeWatchingOverlay), { remainingTime: action.remainingTime }) });
        case actionTypes.SET_IS_ON_LIVE_EDGE:
            return Object.assign(Object.assign({}, state), { isOnLiveEdge: action.isOnLiveEdge });
        default:
            return state;
    }
};
//# sourceMappingURL=reducer.js.map